module.exports = __webpack_public_path__ + "img/folio.a38cc591.gif";